import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ResumoRestricaoService, RestrictionSummary } from './resumo-restricao.service';

@Injectable({
  providedIn: 'root'
})
export class ResumoRestricaoResolver implements Resolve<RestrictionSummary> {
  constructor(private readonly service: ResumoRestricaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<RestrictionSummary> {

    const token = route.paramMap.get('token') ?? '';
    const projectId = route.paramMap.get('projectId') ?? '';
    const restrictionId = route.paramMap.get('restrictionId') ?? '';
    localStorage.setItem('authToken', token);

    let approvedBy: { name: string; email: string } = { name: '', email: '' };
    return this.service.approveRestrictionTokenEmail(token).pipe(

      switchMap((response: any) => {
        approvedBy = response.approvedBy;
        return this.service.fetchSummary(restrictionId)
      }),
      map((summary) => ({ ...summary, approvedBy: approvedBy })),
      catchError(() =>
        this.service.fetchSummary(restrictionId).pipe(
          map((summary) => ({ ...summary, approvalFailed: true }))
        )
      )
    );
  }
}


